import {
  formatAsUnit1,
  type ProductLike,
} from "@/lib/unit-utils";

export type DisplayTier = "unit1" | "unit1_2" | "all";

/**
 * Format a stored eaches quantity for display.
 *
 * Per PR 19 design intent, list/card displays are always Unit 1 only.
 * The `display_tier` setting on products/store_products controls only the
 * INPUT count fields (StockCalculatorInput maxTier), not display output.
 */
export function formatQtyForProduct(
  eaches: number,
  product: ProductLike | null | undefined,
): string {
  return formatAsUnit1(eaches, product);
}
